<template>
  <!--::banner topo::-->
  <section v-if="bannerTopo != ''" class="breadcrumb">
    <div class="img-avance">
      <img :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem" class="bg-img-fill" alt="">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="breadcrumb_iner">
            <div class="breadcrumb_iner_item">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--================Blog Area =================-->
  <section v-if="linhaTextoNoticia != ''" class="blog_area single-post-area area-padding">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div class="col-lg-8 posts-list">
          <div class="single-post">
            <div class="feature-img">
              <img :src="$imgURL + linhaTextoNoticia.insInstitucionalImagens[0].itgUrlImagem" class="img-fluid">
            </div>
            <div class="blog_details">
              <h2>{{ linhaTextoNoticia.itiNome }}
              </h2>
              <p v-html="linhaTextoNoticia.itiResumo1"></p>

              <!-- link para voltar -->
              <div class="text-center">
                <button onclick="history.back()" style="cursor: pointer; color: #131666;">
                  <p style="color: #0047AB;">← Voltar</p>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import { useRoute } from 'vue-router';
import { useHead } from '@vueuse/head';
import axios from 'axios';

export default {
  name: 'BlogDetalheView',

  components: {
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    bannerTopo: [],
    linhaTextoNoticia: [],
    listaNoticias: [],
  }),

  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Garante Max :: ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {

    this.carregaMetas("---");

    // BANNER TOPO
    axios.get('/Process/InsInstitucional/institucional/27/toponoticias/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('banner blog')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
        this.linhaTextoNoticia = response.data;
        this.carregaMetas(this.removerTagsHTML, this.linhaTextoNoticia.itiNome);
        //console.log('this.linhaTextoNoticia')
        //console.log(this.linhaTextoNoticia)
      })
      .catch(error => {
        console.error(error);
      });
  },
}
</script>

<style scoped></style>